"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useStyles = void 0;
var react_1 = __importDefault(require("react"));
var clsx_1 = __importDefault(require("clsx"));
var styles_1 = require("@material-ui/core/styles");
var core_1 = require("@material-ui/core");
exports.useStyles = styles_1.makeStyles(function (theme) {
    return styles_1.createStyles({
        root: {
            textTransform: 'none',
        },
        contained: {
            display: 'inline-block',
            borderRadius: '4px',
            color: '#fff',
            border: 'none',
            outline: 'none',
            textDecoration: 'none',
            background: '#202020',
            fontWeight: 500,
            textAlign: 'center',
            overflow: 'hidden',
            position: 'relative',
            whiteSpace: 'nowrap',
            transform: 'translate3d(0, 0, 0)',
            boxShadow: '0 1px 4px rgba(0, 0, 0, 0.1), 0 2px 4px rgba(0, 0, 0, 0.1)',
            transition: '0.3s',
            '&::before': {
                content: '""',
                position: 'absolute',
                top: 0,
                left: 0,
                width: '100%',
                height: '100%',
                background: 'linear-gradient(to bottom, #fff 0%, #000 100%)',
                zIndex: -1,
                opacity: 0.1,
            },
            '&:hover': {
                boxShadow: '0 6px 7px 0 rgba(0, 0, 0, 0.15), 0 0px 5px 0px rgba(0, 0, 0, 0.1)',
                opacity: '1',
                transform: 'translateY(-2px)',
                transition: '0.35s',
                background: '#202020',
            },
            '&:active': {
                boxShadow: '0 3px 6px 0 rgba(0, 0, 0, 0.1), 0 0px 10px 0 rgba(0, 0, 0, 0.1), 0 1px 4px -1px rgba(0, 0, 0, 0.1)',
                transform: 'translateY(0px)',
                transition: '0.35s',
            },
            '&:disabled': {
                boxShadow: 'none',
                transform: 'translateY(0px)',
            },
        },
        containedPrimary: {
            background: theme.palette.primary.main,
            color: '#fff',
            '&:hover': {
                background: theme.palette.primary.main,
            },
        },
        text: {
            background: 'none',
            transition: theme.transitions.create(['color'], {
                duration: theme.transitions.duration.shortest,
            }),
            color: theme.palette.text.secondary,
            '&:hover, &:focus': {
                background: 'none',
                color: theme.palette.grey[400],
            },
            '&:disabled': {
                color: theme.palette.grey[300],
            },
        },
        textPrimary: {
            color: theme.palette.primary.main,
            '&:hover, &:focus': {
                color: theme.palette.primary.light,
            },
            '&:disabled': {
                color: theme.palette.grey[300],
            },
        },
        textSecondary: {
            color: theme.palette.secondary.main,
            '&:hover, &:focus': {
                color: theme.palette.secondary.light,
            },
            '&:disabled': {
                color: theme.palette.grey[300],
            },
        },
        sizeLarge: {
            padding: '15px 24px 15px',
            lineHeight: '18px',
            fontSize: '18px',
        },
        sizeSmall: {
            fontSize: '14px',
        },
        clear: {
            textDecoration: 'underline',
            transform: 'translateZ(0)',
            transition: 'transform 0.25s ease-out, -webkit-transform 0.25s ease-out',
            color: theme.palette.text.secondary,
            '&:focus': {
                transform: 'scale(1.05)',
                textDecoration: 'underline',
                background: 'none',
                color: theme.palette.text.secondary,
            },
            '&:hover': {
                transform: 'scale(1.05)',
                textDecoration: 'underline',
                background: 'none',
                color: theme.palette.text.secondary,
            },
            '&:active': {
                transform: 'scale(0.9)',
                textDecoration: 'underline',
                background: 'none',
                color: theme.palette.text.secondary,
            },
        },
        flat: {
            borderRadius: 8,
            transition: theme.transitions.create(['background-color'], {
                duration: theme.transitions.duration.shortest,
            }),
        },
        flatPrimary: {
            color: '#FFF',
            backgroundColor: theme.palette.primary.main,
            '&:focus': {
                color: '#FFF',
                backgroundColor: theme.palette.primary.light,
            },
            '&:hover': {
                color: '#FFF',
                backgroundColor: theme.palette.primary['400'],
            },
            '&:active': {
                backgroundColor: theme.palette.primary.dark,
            },
        },
        flatSecondary: {
            color: '#35469C',
            backgroundColor: '#BED0F7',
            '&:focus': {
                color: '#35469C',
                backgroundColor: theme.palette.secondary.light,
            },
            '&:hover': {
                color: '#35469C',
                backgroundColor: theme.palette.secondary.light,
            },
            '&:active': {
                backgroundColor: theme.palette.secondary.main,
            },
        },
        flatDefault: {
            color: '#ECEFF1',
            backgroundColor: '#607D8B',
            '&:focus': {
                color: '#ECEFF1',
                backgroundColor: '#90A4AE',
            },
            '&:hover': {
                color: '#ECEFF1',
                backgroundColor: '#90A4AE',
            },
            '&:active': {
                backgroundColor: '#607D8B',
            },
            '&:disabled': {
                color: '#BDBDBD',
                backgroundColor: '#ECEFF1',
            },
        },
        danger: {
            color: '#FF8A80',
            '&:hover': {
                color: '#FF8A80',
            },
            '&:focus': {
                color: '#FF8A80',
            },
            '&:active': {
                color: '#FF8A80',
            },
            '&:disabled': {
                color: theme.palette.grey[300],
            },
        },
    });
});
var Button = function (_a) {
    var _b;
    var className = _a.className, colorProp = _a.color, variantProp = _a.variant, other = __rest(_a, ["className", "color", "variant"]);
    var classes = exports.useStyles();
    var variant = variantProp;
    var color = colorProp;
    if (variant === 'clear' || variant === 'flat') {
        variant = 'text';
    }
    if (color === 'danger') {
        color = 'inherit';
    }
    return (react_1.default.createElement(core_1.Button, __assign({ disableRipple: true, color: color, variant: variant, classes: {
            root: classes.root,
            contained: classes.contained,
            containedPrimary: classes.containedPrimary,
            text: classes.text,
            textPrimary: classes.textPrimary,
            textSecondary: classes.textSecondary,
            sizeLarge: classes.sizeLarge,
            sizeSmall: classes.sizeSmall,
        }, className: clsx_1.default((_b = {},
            _b[classes.clear] = variantProp === 'clear',
            _b[classes.flat] = variantProp === 'flat',
            _b[classes.flatPrimary] = variantProp === 'flat' && color === 'primary',
            _b[classes.flatSecondary] = variantProp === 'flat' && color === 'secondary',
            _b[classes.flatDefault] = variantProp === 'flat' && color === 'default',
            _b[classes.danger] = colorProp === 'danger',
            _b), className) }, other)));
};
exports.default = Button;
//# sourceMappingURL=Button.js.map